import { get } from 'lodash'

export const getTerritoryOwner = state => {
  const data = get(state, 'coverage.data[0]', [])
  return data.territoryOwner
}
export const getOffersLoading = state => get(state, 'offers.loading')
